import { useNavigate } from "react-router-dom";
import StudentRegister from "@/components/StudentRegister";
import { Link } from "react-router-dom";

export default function StudentRegisterPage() {
  const nav = useNavigate();
  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-4 py-8">
      <StudentRegister onRegistered={() => nav("/student/play")} />
      <div className="mt-6 flex gap-4 text-sm text-steel-300">
        <Link to="/leaderboard" className="hover:text-forge-300">View leaderboard</Link>
        <span>·</span>
        <Link to="/admin/login" className="hover:text-forge-300">Manager sign in</Link>
      </div>
    </main>
  );
}
